// @flow
import type { ChildrenArray, Element, Node } from 'react';
import React from 'react';
import { usePropsValidation } from './validation/runtime-checks/index.js';
import { types as t } from './validation/runtime-checks/index.js';
import type { CompilerInjectedProps } from './validation/runtime-checks/index.js';

const commonStyle = { paddingLeft: 40, margin: '1em 0' };

const List = (props: {|
  type: 'bullet' | 'numbered',
  children: ChildrenArray<Element<typeof ListItem>>,
  ...CompilerInjectedProps,
|}) => {
  const { failedValidation } = usePropsValidation(props, List);
  if (failedValidation) return null;
  const { type, children } = props;
  if (type === 'bullet') {
    return <ul style={{ ...commonStyle, listStyle: 'disc' }}>{children}</ul>;
  }
  if (type === 'numbered') {
    return <ol style={{ ...commonStyle, listStyle: 'decimal' }}>{children}</ol>;
  }
  return null;
};
List.spec = {
  type: t.unionOfValues('bullet', 'numbered'),
  children: t.childrenArray(t.elementType(ListItem)),
};

function ListItem(props: {| children: Node, ...CompilerInjectedProps |}) {
  const { failedValidation, addErrors, locations } = usePropsValidation(
    props,
    ListItem,
  );

  React.useEffect(() => {
    if (!props._performValidation || failedValidation) return;
    const hasListItemChild = React.Children.toArray(props.children).some(
      (child) => child?.type === ListItem,
    );
    if (hasListItemChild) {
      addErrors([
        {
          message: 'ListItem cannot have another ListItem as a direct child',
          ...locations.children,
        },
      ]);
    }
  });

  if (failedValidation) return null;
  const { children } = props;
  return <li>{children}</li>;
}
ListItem.spec = {
  children: t.node,
};

export { List, ListItem };
